module.exports = __webpack_public_path__ + "static/media/loading.bfd369c8.gif";